const modules = document.querySelectorAll("main > *[data-in-view]");

function handleIntersection(entries) {
	entries.map((entry) => {
		if (entry.isIntersecting) {
			if (entry.target.hasAttribute("data-in-view")) {
				entry.target.setAttribute("data-in-view", "true");
			}
		}
	});
}

Array?.from(modules)?.map((module) => {
	const observer = new IntersectionObserver(handleIntersection, {
		threshold: 0.2,
		rootMargin: "48px",
	});
	observer.observe(module);
});
